"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconUiFilter = function IconUiFilter(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  return _react.default.createElement("svg", _extends({
    className: (0, _classnames.default)(className, 'svg-icon'),
    viewBox: "0 0 48 48"
  }, props), _react.default.createElement("path", {
    d: "M13.989 31.011a4 4 0 0 0-3.861 3H4v2h6.128a3.985 3.985 0 0 0 7.723 0H44v-2H17.851a4 4 0 0 0-3.862-3zm0 6A2 2 0 0 1 12 35.155v-.289a1.994 1.994 0 0 1 3.979 0v.289a2 2 0 0 1-1.99 1.856zM44 11.989H17.848a3.98 3.98 0 0 0-7.717 0H4v2h6.131a3.98 3.98 0 0 0 7.717 0H44zm-30.011 3A2 2 0 0 1 12 13.1v-.213a1.992 1.992 0 0 1 3.979 0v.213a2 2 0 0 1-1.99 1.893zM44 23.019h-6.131a3.981 3.981 0 0 0-7.716 0H4v2h26.153a3.981 3.981 0 0 0 7.716 0H44zm-9.989 3a2 2 0 0 1-1.99-1.894v-.213a1.992 1.992 0 0 1 3.979 0v.213a2 2 0 0 1-1.989 1.894z"
  }));
};

IconUiFilter.propTypes = {
  className: _propTypes.default.string
};
var _default = IconUiFilter;
exports.default = _default;